import { ValidatorFn } from '@angular/forms';
export interface IValidator {
    validator: ValidatorFn;
    message: string;
    id: string;
    name: string;
}
